import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
// Consider replacing these images with ones relevant to Radiology/Imaging if available
import radiologyBg1 from './Radiology.png'; // Kept original paths, rename/replace images as needed
import radiologyBg2 from '../../assets/img/clinic//2.png'; // Kept original paths, rename/replace images as needed
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const Radiology = () => { // Changed component name
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    // Use the imported images - update these if you have radiology-specific visuals
    const images = [radiologyBg1]; // Used renamed variables for clarity
     const backgroundImage = images[currentImageIndex];

    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    {/* Updated Breadcrumb */}
                                    <li className="breadcrumb-item active" aria-current="page">Radiology</li>
                                </ol>
                            </nav>
                            {/* Updated Title */}
                            <h2 className="breadcrumb-title">Radiology Department</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text - Kept urology-header class as requested */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         {/* Updated Header Text */}
                                         <strong>Radiology Department at Hitkari Hospital</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">

                             <div className="terms-content">
                                <div className="terms-text">
                                     {/* Updated Content: Introduction */}
                                     <h3>Radiology Department at Hitkari Hospital</h3>
                                       <p>The Radiology Department at Hitkari Hospital is a vital component of patient care, providing comprehensive diagnostic and interventional imaging services. Equipped with advanced imaging technology and staffed by experienced radiologists and certified technologists, we are dedicated to delivering accurate, timely, and safe imaging studies. Our goal is to support physicians in diagnosing conditions effectively and contribute to optimal patient treatment plans through high-quality medical imaging.</p>
                                </div>
                                <div className="terms-text">
                                    {/* Updated Content: Services */}
                                    <h3>Diagnostic Imaging Services Offered</h3>
                                    <h4>1. Digital Radiography (X-ray)</h4>
                                    <ul>
                                        <li>Bone and Joint Imaging: Detecting fractures, arthritis, infections, and dislocations.</li>
                                        <li>Chest Radiography: Evaluating the lungs, heart, and surrounding structures for conditions like pneumonia, tumors, or heart failure.</li>
                                        <li>Abdominal X-rays: Assessing issues such as bowel obstructions or ingested foreign objects.</li>
                                        <li>Specialized X-ray Procedures: Including contrast studies like Barium swallows or enemas when indicated.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       {/* Updated Content: CT Scans */}
                                       <h4>2. Computed Tomography (CT) Scans</h4>
                                        <ul>
                                            <li>Detailed Cross-Sectional Imaging: Providing highly detailed views of internal organs, bones, soft tissues, and blood vessels.</li>
                                            <li>Head and Brain Scans: Essential for diagnosing stroke, trauma, tumors, and bleeding.</li>
                                            <li>Chest, Abdomen, and Pelvis CT: Used to detect cancers, infections, inflammation, vascular issues, and injuries.</li>
                                            <li>CT Angiography (CTA): Visualizing blood vessels to identify blockages, aneurysms, or malformations.</li>
                                            <li>Low-Dose CT Options: Utilized for specific screening purposes, minimizing radiation exposure where possible.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      {/* Updated Content: Ultrasound */}
                                      <h4>3. Ultrasonography (Ultrasound)</h4>
                                      <ul>
                                            <li>Safe, Radiation-Free Imaging: Using sound waves to create real-time images of internal body structures.</li>
                                            <li>Abdominal Ultrasound: Evaluating organs like the liver, gallbladder, kidneys, pancreas, and spleen.</li>
                                            <li>Pelvic Ultrasound: Assessing the uterus, ovaries, and bladder, often used in gynecological and urological evaluations.</li>
                                            <li>Obstetric Ultrasound: Monitoring fetal growth, development, and well-being throughout pregnancy.</li>
                                            <li>Doppler Ultrasound: Evaluating blood flow in arteries and veins to detect clots or blockages.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       {/* Updated Content: Other Imaging (Optional - add MRI/Mammo if needed) */}
                                       <h4>4. Additional Imaging Capabilities</h4>
                                        <ul>
                                            <li>Coordination for Advanced Modalities: Facilitating access to Magnetic Resonance Imaging (MRI) for detailed soft tissue evaluation when necessary.</li>
                                            <li>Mammography Coordination: Assisting with referrals for breast cancer screening and diagnostic mammograms.</li>
                                            {/* Add specific services available at Hitkari like portable X-ray if applicable */}
                                            <li>Portable X-ray Services: Providing bedside imaging for critically ill or immobile patients within the hospital.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                         {/* Updated Content: Interpretation & Safety */}
                                         <h4>5. Image Interpretation and Patient Safety</h4>
                                       <ul>
                                          <li>Expert Radiologist Interpretation: Board-certified radiologists meticulously analyze images and provide detailed diagnostic reports to referring physicians.</li>
                                           <li>Commitment to Radiation Safety: Adhering strictly to ALARA (As Low As Reasonably Achievable) principles to minimize radiation exposure during CT and X-ray procedures.</li>
                                           <li>Quality Control: Regular checks and maintenance of imaging equipment ensure optimal performance and image quality.</li>
                                           <li>Technologist Expertise: Highly trained radiologic technologists perform examinations with precision and patient comfort in mind.</li>
                                       </ul>
                                 </div>
                                  <div className="terms-text">
                                      {/* Updated Content: Why Choose */}
                                    <h3>Why Choose the Radiology Department at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Advanced Imaging Technology: Utilizing modern X-ray, CT, and Ultrasound equipment for clear and accurate diagnoses.</li>
                                           <li>Experienced Radiology Team: Skilled radiologists and technologists committed to excellence in medical imaging.</li>
                                            <li>Comprehensive Service Range: Offering essential diagnostic imaging modalities like X-ray, CT, and Ultrasound.</li>
                                            <li>Focus on Accuracy and Timeliness: Striving for prompt image acquisition, interpretation, and reporting to aid swift medical decisions.</li>
                                           <li>Patient Safety Protocols: Implementing rigorous safety measures, especially concerning radiation protection.</li>
                                           <li>Integrated Care: Working closely with all hospital departments to ensure imaging services effectively support overall patient management.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    {/* Updated Content: Conclusion */}
                                    <p>The Radiology Department at Hitkari Hospital is dedicated to providing superior diagnostic imaging services. Through the use of advanced technology and the expertise of our team, we play a crucial role in accurate disease detection and management, contributing significantly to the quality of care delivered to our patients.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default Radiology; // Make sure to export the correct component name